import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TemplateForm from "../../components/templates/TemplateForm";
import templatesService from "../../services/templatesService";
import { useNotify } from "../../context/NotificationContext";
import { useCommon } from '../../context/CommonContext';
const EditTemplate = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const notify = useNotify();
  const { setPageTitle } = useCommon();
  useEffect(() => {
    setPageTitle("Edit Template");
  }, []);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [data, setData] = useState(null);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await templatesService.getTemplateById(id);
      if (res?.data?.status) {
        setData(res.data.data);
      } else {
        notify.error({ message: res?.data?.message || "Template not found" });
        navigate("/templates");
      }
    } catch (error) {
      console.log("error", error);
      notify.error({
        message: error?.data?.message || "Failed to load template",
      });
      navigate("/templates");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSubmit = async (values) => {
    console.log("values", values);
    try {
      setSaving(true);
      const res = await templatesService.updateTemplate(id, {
        name: values.name,
        description: values.description || null,
        temp_type: values.type || null,
        is_active: values.is_active ?? true,
      });
      notify.success({
        message: res?.data?.message || "Template updated successfully",
      });
      navigate("/templates");
    } catch (error) {
      console.log("error", error);
      notify.error({
        message: error?.data?.message || "Failed to update template",
      });
    } finally {
      setSaving(false);
    }
  };

  const handleBack = () => {
    navigate("/templates");
  };

  if (loading) {
    return (
      <div style={{ textAlign: "center", padding: "50px" }}>
        Loading template...
      </div>
    );
  }

  return (
    <TemplateForm
      initialValues={data}
      loading={saving}
      onSubmit={handleSubmit}
      onBack={handleBack}
      isEdit={true}
    />
  );
};

export default EditTemplate;
